const formController = require("./_form-controller");
const $ = require('jquery');

class OneClickRegistrationButton {
    constructor(ctaAfterSubmission, id) {
        this.ctaAfterSubmission = ctaAfterSubmission;
        this.id = id;

        this.getRoot().on("click", () => this.onClick());
    }

    getRoot() {
        return $(`#${this.id}`);
    }

    hide() {
        this.getRoot().css({ display: 'none' });
    }

    show() {
        this.getRoot().css({ display: 'unset' });
    }

    createLoading() {
        return $(`<figure class="itbl-b-circle__loader" id="itbl-b-loading__home">
            <div class="loader">
                <svg class="circular" viewBox="25 25 50 50">
                    <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"></circle>
                </svg>
            </div>
        </figure>`);
    }

    async onClick() {
        const formData = this.ctaAfterSubmission.loadFormData();

        formData["formid"] = "1212";
        formData["formVid"] = "1212";

        const $loading = this.createLoading();

        this.getRoot().after($loading);
        this.hide();

        try {
            if (window.location.hostname === "localhost") {
                await new Promise(resolve => setTimeout(resolve, 3000));
            } else {
                await formController.marketo__submit(formData);
            }

            let successMessage = '';
            if ('ITBL' in window && 'strings' in window.ITBL && 'cta_after_submission_registration_success_message' in window.ITBL.strings) {
                successMessage = window.ITBL.strings.cta_after_submission_registration_success_message;
            }
            this.getRoot().after(`<span><span class="far fa-3x fa-check-circle"></span><br/><br/>${successMessage ? ' ' + successMessage : ''}</span>`);
        } catch (e) {
            alert("Failed to do one-click registration");
            this.show();
        } finally {
            $loading.remove();
        }
    }
}

module.exports = OneClickRegistrationButton;